import React__default, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { determineDataTestIdPrefix, getBaseProps, getAriaProps } from '../../../helpers/propHelpers.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Card = (props) => {
    const [isCollapsed, setCollapsed] = useState(props.isCollapsed);
    useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.collapsible) {
            setCollapsed(props.isCollapsed);
            props.handleCollapseChange && props.handleCollapseChange(props.isCollapsed);
        }
    }, [props.isCollapsed]);
    const getCardClassNames = () => {
        return classNames({
            Card: true,
            'Card--default': true,
            'Card--flat': props.flat,
        }, props === null || props === void 0 ? void 0 : props.className // Pass-through any classes applied to the card
        );
    };
    const getCardBodyClassNames = () => {
        if (props.collapse) {
            console.warn('collapse is being deprecated and will be removed in future versions.');
            props.noPadding = props.collapse;
        }
        return classNames({
            Card__body: true,
            'Card__body--full-padding': (!props.title && !props.headerActions) || props.showHeaderBottomBorder,
            'Card__body--no-pad': props.noPadding,
            'Card__body--flat': props.flat,
        });
    };
    const getCardHeaderClassNames = () => {
        if (props.collapse) {
            console.warn('collapse is being deprecated and will be removed in future versions.');
            props.noPadding = props.collapse;
        }
        return classNames({
            Card__header: true,
            'Card__header--collapsible': props.collapsible,
            'Card__header--no-pad': props.noPadding,
            'Card__header--flat': props.flat,
            'Card__header--border-bottom': props.showHeaderBottomBorder,
        });
    };
    const getCardHeaderStyle = () => {
        if (!props.headerColor)
            return {};
        return {
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 8px',
            backgroundImage: `linear-gradient(to right, ${props.headerColor},rgba(255, 255, 255, 0.5)), linear-gradient(to right, ${props.headerColor}, ${props.headerColor})`,
        };
    };
    const getCollapseStateClass = () => {
        if (isCollapsed) {
            return 'Card__collapsible-icon--collapsed';
        }
        else {
            return '';
        }
    };
    const handleCardCollapse = (e) => {
        if (props === null || props === void 0 ? void 0 : props.collapsible) {
            switch (e.type) {
                case 'click':
                    props.handleCollapseChange && props.handleCollapseChange(!isCollapsed);
                    setCollapsed(!isCollapsed);
                    break;
                case 'keydown':
                    // Allow ENTER and SPACEBAR to control the collapse when keyboard interacting
                    if (e.keyCode === 13 || e.keyCode === 32) {
                        props.handleCollapseChange && props.handleCollapseChange(!isCollapsed);
                        setCollapsed(!isCollapsed);
                    }
                    break;
            }
        }
    };
    const dataTestId = determineDataTestIdPrefix(props, 'card');
    const baseProps = getBaseProps(props);
    getAriaProps(props);
    return (React__default.createElement("div", Object.assign({}, baseProps, { className: classNames(getCardClassNames(), props === null || props === void 0 ? void 0 : props.className), "data-testid": `${dataTestId}`, style: props === null || props === void 0 ? void 0 : props.style }),
        (props.title || props.headerActions || props.collapsible) && (React__default.createElement("header", { className: getCardHeaderClassNames(), "data-testid": `${dataTestId}-header`, style: getCardHeaderStyle() },
            props.cardImage &&
                (typeof props.cardImage === 'string' ? (React__default.createElement("img", { "data-testid": `${dataTestId}-card-image`, className: "Card__header-card-image", src: props.cardImage, alt: "card-logo" })) : (React__default.createElement("div", { "data-testid": `${dataTestId}-card-image`, className: "Card__header-card-image" }, props.cardImage))),
            React__default.createElement("div", { className: `Card__header-text`, tabIndex: (props === null || props === void 0 ? void 0 : props.collapsible) ? props.tabIndex : 0, role: (props === null || props === void 0 ? void 0 : props.collapsible) ? 'button' : '', onClick: (e) => handleCardCollapse(e), onKeyDown: (e) => handleCardCollapse(e), "data-testid": `${dataTestId}-collapse-trigger` },
                (props === null || props === void 0 ? void 0 : props.collapsible) && (React__default.createElement(FontAwesomeIcon, { className: `Card__collapsible-icon ${getCollapseStateClass()}`, "data-testid": `${dataTestId}-collapse-icon`, icon: "chevron-down" })),
                React__default.createElement("div", { className: "Card__header-titles" },
                    props.title && (React__default.createElement("h2", { className: 'Card__header-title', "data-testid": `${dataTestId}-title` }, props.title)),
                    props.subtitle && React__default.createElement("p", { className: 'Card__header-subtitle' }, props.subtitle))),
            props.headerActions && (React__default.createElement("div", { className: 'Card__header-actions', "data-testid": `${dataTestId}-actions` }, props.headerActions.map((action, i) => (React__default.createElement("div", { className: "Card__header-action", key: i, "data-testid": `${dataTestId}-action` }, action))))))),
        !isCollapsed && (React__default.createElement("div", { className: getCardBodyClassNames(), "data-testid": `${dataTestId}-body` }, props.children && props.children))));
};
Card.defaultProps = {
    collapsible: false,
    isCollapsed: false,
};

export { Card, Card as default };
//# sourceMappingURL=Card.js.map
